import axios from "axios";
import React, { useRef, useState, useEffect } from "react";
import { useHistory, useLocation } from "react-router-dom";
import css from "../css/Addcase.module.css";
import Compressor from "compressorjs";
import css1 from "../css/Pan.module.css";
import Rightcontainer from "../Components/Rightcontainer";
import "../css/Loader.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "../css/viewGame1.css";
import "../css/layout.css";
import Swal from "sweetalert2";
import Header from "../Components/Header";
import socket from "../Components/socket";
import "../css/landing.css";
import Modal from "react-bootstrap/Modal";
import { BsArrowRight, BsQrCodeScan } from "react-icons/bs";
import DownloadLink from "react-download-link";
import Spinner from "react-bootstrap/Spinner";
import SabpaisaPaymentGateway from "./SabpaisaPaymentGateway";
import QRCode from "qrcode.react";
import { apiRequest } from "../store/allApi";
import { TbCoinRupeeFilled } from "react-icons/tb";

const Addcase = ({ walletUpdate }) => {
  // BASE URL
  const [allBank, setAllBank] = useState([]);
  const [acdata, setacdata] = useState("");
  const beckendLocalApiUrl = process.env.REACT_APP_API_BASE_URL;
  const beckendLiveApiUrl = process.env.REACT_APP_API_BASE_URL;
  const nodeMode = process.env.NODE_ENV;
  if (nodeMode === "development") {
    var baseUrl = beckendLocalApiUrl;
  } else {
    baseUrl = beckendLiveApiUrl;
  }
  // +++++++++++++++++++++++++++++
  const [userAllData, setUserAllData] = useState();

  const userData = localStorage.getItem("udata");
  const udata = JSON.parse(userData);

  const phone = localStorage.getItem("phone");

  const [clientCode, setClientCode] = useState("RALY03");
  const [transUserName, setTransUserName] = useState("nightking41232323_15556");
  const [transUserPassword, setTransUserPassword] = useState("RALY03_SP15556");
  const [authkey, setAuthkey] = useState("b5gF6mGKDHicH6WB");
  const [authiv, setAuthiv] = useState("wD6KKUsCumUEeogG");

  // sabpay
  // alert(udata.Name.replace(/[^a-zA-Z0-9]/g,''))
  const [payerName, setPayerName] = useState(
    udata.Name.replace(/[^a-zA-Z0-9]/g, ""),
  );
  const [payerEmail, setPayerEmail] = useState(udata.Email);
  const [payerMobile, setPayerMobile] = useState(phone);

  const [clientTxnId, setclientTxnId] = useState(null);

  const [payerAddress, setPayerAddress] = useState("Kolkata");
  const [callbackUrl, setCallbackUrl] = useState("/sabpaisaGateway");

  const [isOpen, setIsOpen] = useState(false);

  const history = useHistory();

  const access_token = localStorage.getItem("token");

  const [isLoading1, setIsloading1] = useState(false);
  const [global, setGlobal] = useState(10.0);
  const [next, setNext] = useState(1);
  const [process1, setProcess] = useState(false);
  const [isMypayInActive, setIsMyPayActive] = useState(false);
  const [isUpiGateway, setUpiGateway] = useState(false);
  const [RazorDeposit, setRazorDeposit] = useState(false);
  const [manualDeposit, setManualDeposit] = useState(false);
  const [imbupiGateway2, setimbupiGateway2] = useState(false);

  const [manualData, setManualData] = useState([]);
  const [PayOneImage, setPayOneImage] = useState("");
  const [PayTwoImage, setPayTwoImage] = useState("");
  const [PayThreeImage, setPayThreeImage] = useState("");
  const [PayFourImage, setPayFourImage] = useState("");
  const [PayFiveImage, setPayFiveImage] = useState("");

  // hooks for payment url
  const [PayNow1Url, setPaynow1Url] = useState("");
  const [PayNow2Url, setPaynow2Url] = useState("");
  const [PayNow3Url, setPaynow3Url] = useState("");
  const [PayNow4Url, setPaynow4Url] = useState("");
  const [PayNow5Url, setPaynow5Url] = useState("");

  const [show_won, setShow_won] = useState(false);
  const [show_won1, setShow_won1] = useState(false);
  const handleClose_won = () => setShow_won(false);
  const [scrnshot, setScrnshot] = useState(null);
  const [fecthStatus, setFecthStatus] = useState();
  const handleShow_won = () => setShow_won(true);
  const handleShow_won1 = () => setShow_won1(true);
  const handleClose_won1 = () => setShow_won1(false);
  const [scrnshot1, setScrnshot1] = useState("");

  const [isLoading, setIsLoading] = useState(false);

  const [minLimit, setMinLimit] = useState(null);
  const [maxLimit, setMaxLimit] = useState(null);
  const [utr, setutr] = useState("");

  // console.log(maxLimit)

  const addsetting = localStorage.getItem("sitSetting");
  const addCaseSetting = JSON.parse(addsetting);
  const [isMobile, setMobile] = useState(false);

  // Hoada Hooks

  const [hoadaPay, setHoadaPay] = useState(false);

  const detail = localStorage.getItem("");

  useEffect(() => {
    setMinLimit(addCaseSetting.depositlimitMin);
    setMaxLimit(addCaseSetting.depositlimitMax);
  }, []);

  // acount upi deposit

  const bankList = async () => {
    const access_token = localStorage.getItem("token");
    const headers = {
      Authorization: `Bearer ${access_token}`,
    };
    try {
      const res = await apiRequest(`get/allbank`, "GET", null, headers);
      //  setLoading(false)
      setAllBank(res.data?.data);
      // console.log(allBank.maxLimit,"soorma")
    } catch (e) {
      // setLoading(false)
      console.log(e);
    }
  };

  const myBank = (data, type) => {
    setNext(4);
    setacdata(data);
  };

  useEffect(() => {
    console.log(next);
    bankList();
  }, []);

  // copy details

  const copyCode1 = (e) => {
    navigator.clipboard.writeText(e);

    Swal.fire({
      position: "center",
      icon: "success",
      type: "success",
      title: "Copy SuccessFully",
      showConfirmButton: false,
      timer: 1200,
    });
  };

  const handleNext = () => {
    // if (payerEmail == null) {
    //   Swal.fire({
    //     title: `Invalid Email Please Update your email from profile page`,

    //     confirmButtonText: "OK",
    //     content: "custom-swal-content",
    //   });
    // }
    // else
    if (global < minLimit || global > maxLimit) {
      Swal.fire({
        title: `Minimum amount should be greater than ${minLimit} and maximum amount should be less than ${maxLimit}`,

        confirmButtonText: "OK",
        content: "custom-swal-content",
      });
    } else {
      setNext(2);
    }
  };

  const [paymentMethod, setPaymentMethod] = useState("");
  const [nextStep, setNextStep] = useState(null);

  // Handle selection change
  const handlePaymentMethodChange = (event) => {
    const selectedMethod = event.target.value;
    setPaymentMethod(selectedMethod);

    // Example logic to handle different options
    if (selectedMethod === "Account") {
      setNextStep(6); // Update the next step based on selection
    } else {
      setNextStep(7); // Reset or handle other cases
    }
  };

  // upigateway

  const upigateway = async () => {
    setProcess(true);
    const access_token = localStorage.getItem("token");
    const headers = {
      Authorization: `Bearer ${access_token}`,
    };
    try {
      const res = await apiRequest(
        `zapupi/payin?amount=${global.toFixed(2)}`,
        "POST",
        { amount: global },
        headers,
      );
      if (res.data.data.status) {
        window.open(res.data?.data?.payment_url);
        // console.log(res.data.data.data.payment_url)
        // console.log(res.data.data.data.order_id)
        let order_id = res.data.txnID;
        let order_token = res.data?.data?.data?.order_id;
        //setProcess(false);
        setTimeout(() => {
          checkupideposit(order_id, order_token);
          setProcess(false);
        }, 60000);
      } else {
        setProcess(false);
        Swal.fire({
          title: res.data.data.msg,
          icon: "danger",
          confirmButtonText: "OK",
        });
      }
    } catch (e) {
      alert(e);
    }
  };

  // razorpay pay

  const razorpay = async () => {
    window.open(
      `https://digitalitems.in/checkout?name=${udata.Name}&email=${udata.Email}&user_id=${udata._id}&mobile=${payerMobile}&amount=${global}`,
      "_blank", // Opens in a new tab
    );
  };

  const [upiLink, setUpiLink] = useState("");

  const checkupideposit = (order_id, order_token) => {
    const access_token = localStorage.getItem("token");
    const headers = {
      Authorization: `Bearer ${access_token}`,
    };
    axios
      .post(
        baseUrl + `depositupipay/response`,
        { order_id, order_token },
        { headers },
      )
      .then((res) => {
        const icon = res.data.status == "PAID" ? "success" : "danger";
        const title =
          res.data.status == "PAID"
            ? "Deposit submited successfully"
            : "Transaction Failed";
        history.push("/");
        setTimeout(() => {
          Swal.fire({
            title: title,
            icon: icon,
            confirmButtonText: "OK",
          });
        }, 1000);
      })
      .catch((e) => {
        if (e.response.status == 401) {
          localStorage.removeItem("token");
          localStorage.removeItem("token");
          window.location.reload();
        }
      });
  };

  const meeApi = async () => {
    let access_token = localStorage.getItem("token");
    const headers = {
      Authorization: `Bearer ${access_token}`,
    };
    try {
      const res = await apiRequest(`me`, "GET", null, headers);
      if (res.data) {
        setUserAllData(res.data);
        setPayerMobile(res.data.Phone);
      }
    } catch (e) {
      if (e.response?.status == 401) {
        localStorage.removeItem("token");
        localStorage.removeItem("token");
        window.location.reload();
        history.push("/login");
      }
    } finally {
    }
  };
  //imbpayment
            const IMBTwo = async () => {
              setProcess(true);
              let access_token = localStorage.getItem("token");
                const headers = {
                  Authorization: `Bearer ${access_token}`,
                };
          
              const res = await apiRequest(
                "imb/payin2",
                "POST",
                { amount: global },
                headers,
              );
              setProcess(false);
              if (res.data.status == false) {
                setProcess(false);
                Swal.fire({
                  title: res.data.msg,
                  icon: "danger",
                  confirmButtonText: "OK",
                });
              } else if (res.data) {
                setProcess(false);
                let order_id = res.data.txnID;
                let order_token = res.data.paymentReferenceId;
                //setProcess(false);
          
                if (res.data) {
                  console.log(res.data);
                  setProcess(false);
                  window.open(res.data?.data?.result?.payment_url, "_blank");
                }
              } else {
                setProcess(false);
                Swal.fire({
                  title: res.data.status,
                  icon: "danger",
                  confirmButtonText: "OK",
                });
              }
            };

  const webSetting = async () => {
    let access_token = localStorage.getItem("token");
    const headers = {
      Authorization: `Bearer ${access_token}`,
    };

    try {
      const res = await apiRequest(`website/setting`, "GET", null, headers);
      if (res.data) {
        setupi(res.data.upiId);
        setUpiGateway(res.data.isUpiGateway);
        setManualDeposit(res.data.manualDeposit);
        setimbupiGateway2(res.data.imbupiGateway2);
      }
    } catch (e) {
      setUpiGateway(false);
    } finally {
    }

    if (
      /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
        navigator.userAgent,
      )
    ) {
      setMobile(true);
    }
  };

  useEffect(() => {
    meeApi();
    webSetting();
  }, []);

  useEffect(() => {}, []);

  // clear Image
  const clearImage = (e) => {
    setScrnshot1(null);
    setScrnshot(null);
  };
  // MANUAL PAYMENTS METHODS API

  const handleChange = (e) => {
    setScrnshot1(URL.createObjectURL(e.target.files[0]));
    const image = e.target.files[0];
    if (image && image.size / 1000 > 300) {
      console.log(" compression");
      new Compressor(image, {
        quality: 0.6,
        success(compressedResult) {
          if (compressedResult) {
            setScrnshot(compressedResult);
          } else {
            setScrnshot(image);
          }
        },
      });
    } else {
      setScrnshot(e.target.files[0]);
    }
  };

  const ManualPayment = async () => {
    let access_token = localStorage.getItem("token");
    const headers = {
      Authorization: `Bearer ${access_token}`,
    };

    try {
      const result = await apiRequest(
        `gatewaysettings/data`,
        "GET",
        null,
        headers,
      );
      // const result = res.json()
      if (result) {
        console.log(result);
        setManualData(result.data);
        setRazorDeposit(result?.data?.RazorDeposit);
        setPayOneImage(result?.data?.isPayOneImage);
        setPayTwoImage(result?.data?.isPayTwoImage);
        setPayThreeImage(result?.data?.isPayThreeImage);
        setPayFourImage(result?.data?.isPayFourImage);
        setPayFiveImage(result?.data?.isPayFiveImage);
        setimbupiGateway2(result?.data?.imbupiGateway2);
      }
    } catch (e) {
      console.log("error", e);
    } finally {
    }
  };

  useEffect(() => {
    ManualPayment();
  }, []);

  // getImage URl
  const [ImageUrl, setImageUrl] = useState("");
  const [PaymentLink, setPaymentLink] = useState("");
  const [upi, setupi] = useState("");

  const getImageUrl = (image, url) => {
    setImageUrl(image);
    setPaymentLink(url);
  };

  // code link payment

  const copyCode = (e) => {
    navigator.clipboard.writeText(upi);

    Swal.fire({
      position: "center",
      icon: "success",
      type: "success",
      title: "Link Copied",
      showConfirmButton: false,
      timer: 1200,
    });
  };

  const ManualPayments = async () => {
    let access_token = localStorage.getItem("token");
    const headers = {
      Authorization: `Bearer ${access_token}`,
    };

    setIsloading1(true);
    var formdata = new FormData();
    formdata.append("Transaction_Screenshot", scrnshot);
    formdata.append("amount", global);
    formdata.append("referenceId", utr);

    try {
      const result = await apiRequest(
        `manual/deposit/txn`,
        "POST",
        formdata,
        headers,
      );
      // const result = await res?.json(); // Await the JSON parsing
      console.log(result.data.data);
      if (result) {
        setIsloading1(false);
        if (result.data.data?.status === "Pending") {
          Swal.fire({
            title: result.data.message,
            icon: "success",
            confirmButtonText: "OK",
          });
        } else {
          Swal.fire({
            title: result.data.message,
            icon: "error",
            confirmButtonText: "OK",
          });
        }

        history.push("/");
        handleClose_won();
      }
    } catch (e) {
      console.log("error", e);
    } finally {
    }
  };

  const handleSetAmount = (amount) => {
    setGlobal(amount);
  };

  return (
    <>
      <Header user={userAllData} />
      <div className="leftContainer mb_space">
        <div className="pt-5 mt-5  Orher_page_main_section">
          <div className="gameCard pt-2">
            <div className="alrt_msg_div">
              <h5 className="">
                {JSON.parse(localStorage.getItem("sitSetting")) == "undefined"
                  ? ""
                  : JSON.parse(localStorage.getItem("sitSetting"))
                      ?.deposit_message}
              </h5>
            </div>
          </div>
          <>
            <section className="win_modal">
              <Modal
                show={show_won1}
                onHide={handleClose_won1}
                className="cancel_popup_reason_popup"
                aria-labelledby="contained-modal-title-vcenter"
                centered
              >
                <Modal.Header closeButton></Modal.Header>
                <Modal.Body>
                  {upiLink && (
                    <div>
                      {/* <QRCode value={upiLink} size={256} /> */}
                      <iframe
                        src={upiLink}
                        title="QR Code"
                        style={{
                          width: "100%",
                          height: "400px",
                          border: "none",
                        }}
                      ></iframe>
                    </div>
                  )}

                  <button
                    type="button"
                    className="close-button "
                    onClick={handleClose_won1}
                  >
                    Close
                  </button>
                </Modal.Body>
              </Modal>
            </section>
          </>
          {Boolean(!process1) && (
            <div>
              {Boolean(next == 1) && (
                <div className="cash_add_v4">
                    <div className="cash_header_v4">
                      <div>
                        <h2>Add Cash</h2>
                        <p>Choose an amount or enter a custom value</p>
                      </div>

                      <div className="wallet_chip">
                        💰 Instant Deposit
                      </div>
                    </div>                   

                    {/* Quick Select */}

                    {/* Custom Amount */}

                    <div className="custom_amount_card">

                      <label>Custom Amount</label>

                      <div className="amount_input_wrap">

                        <span className="rupee_icon">
                          ₹
                        </span>

                        <input
                          type="tel"
                          value={global}
                          placeholder="Enter Amount"
                          onChange={(e) => {
                            e.target.value > 0
                              ? e.target.value <= 50000
                                ? setGlobal(parseInt(e.target.value))
                                : setGlobal(50000)
                              : e.target.value < 0
                              ? setGlobal(10)
                              : setGlobal(0);
                          }}
                        />

                      </div>

                      <div className="limit_info">
                        Min ₹{minLimit} • Max ₹{maxLimit}
                      </div>

                       <div className="quick_amount_grid">
                        {[250, 500, 1000, 2000].map((amount) => (
                          <button
                            key={amount}
                            className={`amount_chip ${
                              global === amount ? "active_chip" : ""
                            }`}
                            onClick={() => handleSetAmount(amount)}
                          >
                            <img
                              src="/images/coin-cc.png"
                              alt=""
                            />
                            ₹{amount}
                          </button>
                        ))}
                      </div>

                    </div>

                    {/* CTA */}

                    {addCaseSetting.isDeposit ? (
                      <button
                        className="deposit_cta_v4"
                        onClick={handleNext}
                      >
                        Continue Payment
                        <BsArrowRight />
                      </button>
                    ) : (
                      <div className="deposit_closed_box">
                        🚫 Deposit service temporarily unavailable
                      </div>
                    )}

                  </div>
              )}

              {Boolean(next == 2) && (
                <div className="">
                  <>
                    <div className="pb-3">
                      <div className={`${css.games_section}`}>
                        <div className="d-flex position-relative align-items-center justify-content-between">
                          <div className="add_cash_small_haedings">
                            Amount to be added ₹<b>{global}</b>
                          </div>

                          <button
                            type="button"
                            onClick={() => setNext(1)}
                            className="samll_btn"
                          >
                            Edit
                          </button>
                        </div>
                      </div>
                    </div>

                    <div className="mt-1">
                      <div
                        className="profile_headings"
                        style={{ color: "black" }}
                      >
                        Pay Through QR CODE
                      </div>

                      {/* upigateway */}
                      {global >= manualData?.upigatewayMin &&
                        Boolean(isUpiGateway) &&
                        global <= manualData?.upigatewayMax && (
                          <div
                            onClick={() => upigateway()}
                            className="add-fund-box mt-3"
                            style={{ paddingTop: "0px", height: "60px" }}
                          >
                            {isLoading ? (
                              <div
                                className="loaderReturn"
                                style={{ zIndex: "99" }}
                              >
                                <img
                                  src={"/images/LandingPage_img/loader1.gif"}
                                  style={{ width: "100%" }}
                                />
                              </div>
                            ) : (
                              <div
                                className="d-flex align-items-center"
                                style={{
                                  backgroundColor: "#fafafa",
                                  border: "1px solid #e0e0e0",
                                  borderRadius: "7px",
                                }}
                              >
                                <div
                                  className="d-flex align-items-center"
                                  style={{
                                    height: "60px",
                                    display: "flex",
                                    textAlign: "center",
                                  }}
                                >
                                  <img
                                    width="40px"
                                    src="/UPI.png"
                                    alt=""
                                    style={{
                                      marginLeft: "7px",
                                      paddingBottom: "10px",
                                      paddingLeft: "3px",
                                      paddingTop: "5px",
                                    }}
                                  />
                                </div>
                                <div className="d-flex justify-content-center flex-column ml-4">
                                  <div className="jss30">
                                    <strong>Pay Now</strong>
                                  </div>
                                  <div className="jss31"></div>
                                </div>
                              </div>
                            )}
                          </div>
                        )}
                      {/* rozerpay */}
                      {/* {Boolean(RazorDeposit) && ( */}
                      {global >= manualData?.gatewayMin &&
                        Boolean(RazorDeposit) &&
                        global <= manualData?.gatewayMax && (
                          <div
                            onClick={() => razorpay()}
                            className="add-fund-box mt-3"
                            style={{ paddingTop: "0px", height: "60px" }}
                          >
                            {isLoading ? (
                              <div
                                className="loaderReturn"
                                style={{ zIndex: "99" }}
                              >
                                <img
                                  src={"/images/LandingPage_img/loader1.gif"}
                                  style={{ width: "100%" }}
                                />
                              </div>
                            ) : (
                              <div
                                className="d-flex align-items-center"
                                style={{
                                  backgroundColor: "#fafafa",
                                  border: "1px solid #e0e0e0",
                                  borderRadius: "7px",
                                }}
                              >
                                <div
                                  className="d-flex align-items-center"
                                  style={{
                                    height: "60px",
                                    display: "flex",
                                    textAlign: "center",
                                  }}
                                >
                                  <img
                                    width="40px"
                                    src="/UPI.png"
                                    alt=""
                                    style={{
                                      marginLeft: "7px",
                                      paddingBottom: "10px",
                                      paddingLeft: "3px",
                                      paddingTop: "5px",
                                    }}
                                  />
                                </div>
                                <div className="d-flex justify-content-center flex-column ml-4">
                                  <div className="jss30">
                                    <strong>Pay With Gateway</strong>
                                  </div>
                                  <div className="jss31"></div>
                                </div>
                              </div>
                            )}
                          </div>
                        )}

                              { Boolean(imbupiGateway2)  &&
                          global >= manualData?.imbLimitMin2  &&
                      global <= manualData?.imbLimitMax2 ? (
                  <div
                    onClick={() => IMBTwo()}
                    className="add-fund-box mt-3"
                    style={{ paddingTop: "0px", height: "60px" }}
                  >
                    {isLoading ? (
                      <div
                        className="loaderReturn"
                        style={{ zIndex: "99" }}
                      >
                        <img
                          src="/images/LandingPage_img/loaderred.gif"
                          style={{ width: "100%" }}
                        />
                      </div>
                    ) : (
                      <div
                        className="d-flex align-items-center"
                        style={{
                          backgroundColor: "#f9dd2c",
                          border: "1px solid #e0e0e0",
                          borderRadius: "49px",
                        }}
                      >
                        <div
                          className="d-flex align-items-center"
                          style={{
                            height: "60px",
                            display: "flex",
                            textAlign: "center",
                          }}
                        >
                          <img
                            width="40px"
                            src="/UPI.png"
                            alt="UPI Icon"
                            style={{
                              marginLeft: "7px",
                              paddingBottom: "10px",
                              paddingLeft: "3px",
                              paddingTop: "5px",
                            }}
                          />
                        </div>
                        <div className="d-flex justify-content-center flex-column ml-4">
                          <div className="jss30">
                            <strong style={{ color: "black" }}>
                              Pay Now 2
                            </strong>
                          </div>
                          <div className="jss31"></div>
                        </div>
                      </div>
                    )}
                  </div>
                ) 
                
                
                : null}
                      <>
                        {allBank?.map((item, index) => (
                          <div>
                            {item?.status &&
                            global > item?.minLimit &&
                            global <= item?.maxLimit ? (
                              <div>
                                <div
                                  onClick={() => myBank(item)}
                                  className="add-fund-box mt-3"
                                  style={{
                                    paddingTop: "0px",
                                    height: "60px",
                                    cursor: "pointer",
                                  }}
                                >
                                  <div
                                    className="d-flex align-items-center"
                                    style={{
                                      backgroundColor: "#fafafa",
                                      border: "1px solid #e0e0e0",
                                      borderRadius: "7px",
                                    }}
                                  >
                                    <div
                                      className="d-flex align-items-center"
                                      style={{
                                        height: "60px",
                                        display: "flex",
                                        textAlign: "center",
                                      }}
                                    >
                                      <img
                                        width="40px"
                                        src="/Bank.png"
                                        alt=""
                                        style={{
                                          marginLeft: "7px",
                                          paddingBottom: "10px",
                                          paddingLeft: "3px",
                                          paddingTop: "5px",
                                        }}
                                      />
                                    </div>
                                    <div className="d-flex justify-content-center flex-column ml-4">
                                      <div className="jss30">
                                        <strong style={{ color: "black" }}>
                                          PAY WITH QR-CODE OR UPI-ID
                                        </strong>
                                      </div>
                                      <div className="jss31"></div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            ) : (
                              ""
                            )}
                          </div>
                        ))}
                      </>

                      {/* Account Deposite */}
                    </div>
                  </>
                </div>
              )}

              {/* Account deposite */}

              {Boolean(next == 4) && (
                <>
                  {console.log(1)}
                  <div className="pb-3">
                    <div className={`${css.games_section}`}>
                      <div className="d-flex position-relative align-items-center justify-content-between">
                        <div className="add_cash_small_haedings">
                          Amount to be added ₹<b>{global}</b>
                        </div>

                        <button
                          type="button"
                          onClick={() => setNext(1)}
                          className="samll_btn"
                        >
                          Edit
                        </button>
                      </div>
                    </div>
                  </div>

                  {acdata?.accountNumber ? (
                    <>
                      <div class="alrt_deposit">
                        <div className="Refer_code">
                          <p style={{ fontSize: "20px" }}>
                            Bank Name :{" "}
                            <span style={{ color: "red" }} className="mb-4">
                              {acdata?.bankName}
                            </span>
                          </p>
                        </div>
                      </div>
                      <div class="alrt_deposit">
                        <div className="Refer_code">
                          <p style={{ fontSize: "20px" }}>
                            Account Number :{" "}
                            <span style={{ color: "red" }} className="mb-4">
                              {acdata?.accountNumber}
                            </span>
                          </p>
                          <button
                            onClick={() => copyCode1(acdata?.accountNumber)}
                          >
                            Copy
                          </button>
                        </div>
                      </div>
                      <div class="alrt_deposit">
                        <div className="Refer_code">
                          <p style={{ fontSize: "20px" }}>
                            Beneficiary Name :{" "}
                            <span style={{ color: "red" }} className="mb-4">
                              {acdata?.accountHolderName}
                            </span>
                          </p>
                          <button
                            onClick={() => copyCode1(acdata?.accountHolderName)}
                          >
                            Copy
                          </button>
                        </div>
                      </div>
                      <div class="alrt_deposit">
                        <div className="Refer_code">
                          <p style={{ fontSize: "20px" }}>
                            IFSC Code :{" "}
                            <span style={{ color: "red" }} className="mb-4">
                              {acdata?.ifscCode}
                            </span>
                          </p>
                          <button onClick={() => copyCode1(acdata?.ifscCode)}>
                            Copy
                          </button>
                        </div>
                      </div>
                    </>
                  ) : (
                    ""
                  )}

                  {acdata?.upiId || acdata?.qrcodeImage ? (
                    <>
                      <div>
                        {/* Show QR if limit is below 2000 */}

                        <>
                          {acdata?.qrcodeImage ? (
                            <div className="Refer_code_2 style-1">
                              <img
                                src={baseUrl + `/${acdata?.qrcodeImage}`}
                                alt="QR Code"
                                style={{ width: "100%" }}
                              />
                              <p
                                style={{
                                  marginTop: "10px",
                                  fontSize: "14px",
                                  color: "#333",
                                }}
                              ></p>
                            </div>
                          ) : (
                            ""
                          )}
                          <div class="d-flex justify-content-between align-items-center border border-1 p-2 mb-3 rounded">
                            <p class="mb-0">UPI ID:</p>
                            <p class="mb-0 text-danger">{acdata?.upiId}</p>
                            <div
                              class="btn btn-primary text-light py-2 px-3"
                              onClick={(e) => copyCode1(acdata?.upiId)}
                            >
                              Copy
                            </div>
                          </div>
                        </>
                      </div>
                    </>
                  ) : (
                    ""
                  )}

                  <div>
                    <p>
                      NOTE :- पेमेंट सक्सेस होने के बाद निचे दिय गए बटन पर क्लिक
                      करके स्क्रीनशॉट और UTR नंबर डालके सबमिट कर दे |
                    </p>
                  </div>

                  <div className="mb-5 d-flex justify-content-center">
                    <button
                      className="results_btn results_btn_win mt-2"
                      onClick={handleShow_won}
                    >
                      {" "}
                      Upload Payment Details
                    </button>
                  </div>
                </>
              )}
            </div>
          )}

          {Boolean(process1) && (
            <div className="loaderReturn" style={{ zIndex: "99" }}>
              <img
                src={"/images/LandingPage_img/loader1.gif"}
                style={{ width: "100%" }}
              />
            </div>
          )}
        </div>
      </div>

      <section className="win_modal">
        <Modal
          show={show_won}
          onHide={handleClose_won}
          className="cancel_popup_reason_popup"
          aria-labelledby="contained-modal-title-vcenter"
          centered
        >
          <Modal.Header closeButton></Modal.Header>
          <Modal.Body>
            <div>
              <h3>Payment Details</h3>
              <div>
                <lable className="commaon_label">AMOUNT</lable>
                <input
                  className="commaon_input_box mb-2"
                  type="number"
                  required
                  value={global}
                  onChange={(e) => setGlobal(e.target.value)}
                  placeholder="Enter amount"
                  readOnly
                />
                <lable className="commaon_label mt-4">UTR NUMBER</lable>
                <input
                  className="commaon_input_box"
                  type="text"
                  required
                  value={utr}
                  onChange={(e) => setutr(e.target.value)}
                  placeholder="Enter UTR Number"
                />
              </div>

              <div className={`${css1.doc_upload} mt-4 upload_ss_btn`}>
                <input
                  type="file"
                  onChange={handleChange}
                  accept="image/*"
                  required
                />
                {!scrnshot && (
                  <div className="cxy flex-column position-absolute ">
                    <i
                      className="fa-solid fa-arrow-up"
                      style={{ color: "#fff" }}
                    ></i>
                    <div
                      className={`${css1.sideNav_text} mt-2 upload_ss_btn_name`}
                    >
                      Upload screenshot.
                    </div>
                  </div>
                )}
                {scrnshot && (
                  <div className={css1.uploaded}>
                    <img
                      src="/images/file-icon.png"
                      width="26px"
                      alt=""
                      style={{ marginRight: "20px" }}
                    />
                    <div
                      className="d-flex flex-column"
                      style={{ width: "80%" }}
                    >
                      <div
                        className={`${css1.name} `}
                        style={{ color: "#fff" }}
                      >
                        {scrnshot.name}
                      </div>
                      <div className={css1.size}>
                        {(scrnshot.size / 1024 / 1024).toFixed(2)} MB
                      </div>
                    </div>
                    <div className="image-block">
                      <img
                        src="/images/global-cross.png"
                        width="10px"
                        alt=""
                        onClick={() => {
                          clearImage();
                          handleClose_won();
                        }}
                      />
                    </div>
                  </div>
                )}
              </div>

              <div style={{ width: "100%", marginTop: "20px" }}>
                <img
                  src={scrnshot1}
                  style={{ width: "100%" }}
                  className="screenshot_img"
                />
              </div>

              {fecthStatus == null && fecthStatus == undefined && (
                <>
                  {isLoading1 ? (
                    <button className="Login-button cxy" disabled>
                      <Spinner
                        as="span"
                        animation="grow"
                        size="sm"
                        role="status"
                        aria-hidden="true"
                      />
                      Loading...
                    </button>
                  ) : (
                    <input
                      type="submit"
                      value="Submit"
                      className="btn btn-danger mt-3 text-white results_btn w-100"
                      id="post"
                      onClick={ManualPayments}
                      disabled={!utr}
                    />
                  )}
                </>
              )}
            </div>
          </Modal.Body>
        </Modal>
      </section>

      <SabpaisaPaymentGateway
        clientCode={clientCode}
        transUserName={transUserName}
        transUserPassword={transUserPassword}
        authkey={authkey}
        authiv={authiv}
        payerName={payerName}
        payerEmail={payerEmail}
        payerMobile={payerMobile}
        clientTxnId={clientTxnId}
        amount={global}
        payerAddress={payerAddress}
        callbackUrl={callbackUrl}
        isOpen={isOpen}
      />

      <div className="rightContainer">
        <Rightcontainer />
      </div>
    </>
  );
};

export default Addcase;
